import { render, staticRenderFns } from "./UserFavoritesSearch.vue?vue&type=template&id=fca20d48&scoped=true&"
import script from "./UserFavoritesSearch.vue?vue&type=script&lang=js&"
export * from "./UserFavoritesSearch.vue?vue&type=script&lang=js&"
import style0 from "./UserFavoritesSearch.vue?vue&type=style&index=0&id=fca20d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca20d48",
  null
  
)

export default component.exports